import React, { FunctionComponent, ReactNode } from 'react';
import { Typography } from '@cfa/react-components';

import './PageHeader.scss';

interface IPageHeaderProps {
    right?: ReactNode;
    title?: ReactNode;
    top?: ReactNode;
}

export const PageHeader: FunctionComponent<IPageHeaderProps> = (props) => (
    <div className="pageHeader">
        {props.top && (
            <div className="pageHeader_top">{props.top}</div>
        )}
        <div className="pageHeader_titleWrapper">
            <Typography variant="h2">{props.title}</Typography>
            {props.right && (
                <div className="pageHeader_right">{props.right}</div>
            )}
        </div>

    </div>
);
